require('jquery');
require('@fengyuanchen/datepicker');
require('slick-carousel');
require("slick-carousel/slick/slick.css");
require('layui-layer');
require('js-cookie');
require('raf.js');
require('flyjs');
require('normalize.css');
